import { ConsultaSeguimentoPergunta04Model } from './model-consultaSeguimentoPergunta04'

export function prunePergunta04(value: ConsultaSeguimentoPergunta04Model): ConsultaSeguimentoPergunta04Model {
  return value
}
